// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pet-blurb[data-v-73c0a744]{padding-left:10px;padding-right:10px;text-align:left}.paw-print[data-v-73c0a744]{width:60px;margin-right:10px;margin-left:10px}.line-only[data-v-73c0a744]{height:0}.pet-summary[data-v-73c0a744]{padding-top:15px;padding-bottom:15px}.pet-name[data-v-73c0a744]{font-size:1.5rem}.avatar-background[data-v-73c0a744]{width:110px;height:110px}", ""]);
// Exports
module.exports = exports;
